import { StyledSpinnerContainer, StyledSpinnerSpan } from './Spinner.styled';

interface ISpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
	color?: string;
}

const Spinner = ({ color, ...props }: ISpinnerProps) => {
	return (
		<StyledSpinnerContainer {...props}>
			<StyledSpinnerSpan color={color} />
		</StyledSpinnerContainer>
	);
};

export { Spinner };
